import { Module } from 'vuex';

import { CONTAINER, TYPES } from '../../config';

import { YearlySummaryState } from '../../models';

import { StorageService } from '../../services';

import { SetYearlySummaryAlreadyViewedAction } from './actions/set-yearly-summary-already-viewed.action';
import { YearlySummaryAlreadyViewedGetter } from './getters/yearly-summary-already-viewed.getter';
import { SetYearlySummaryAlreadyViewedMutation } from './mutations/set-yearly-summary-already-viewed.mutation';
import { YEARLY_SUMMARY_CONSTS } from './yearly-summary.consts';

export const YEARLY_SUMMARY_MODULE: Module<YearlySummaryState, any> = {
  namespaced: true,

  state: (): YearlySummaryState => {
    const storageService: StorageService = CONTAINER.get<StorageService>(TYPES.StorageService);
    const yearlySummaryAlreadyViewed = storageService.getItem(YEARLY_SUMMARY_CONSTS.storage.yearlySummaryAlreadyViewed);
    return {
      viewed: (yearlySummaryAlreadyViewed !== null ? (yearlySummaryAlreadyViewed === 'true') : false)
    };
  },

  getters: {
    [YEARLY_SUMMARY_CONSTS.getters.yearlySummaryAlreadyViewed]: YearlySummaryAlreadyViewedGetter.execute
  },

  actions: {
    [YEARLY_SUMMARY_CONSTS.actions.setYearlySummaryAlreadyViewed]: SetYearlySummaryAlreadyViewedAction.execute
  },

  mutations: {
    [YEARLY_SUMMARY_CONSTS.mutations.setYearlySummaryAlreadyViewed]: SetYearlySummaryAlreadyViewedMutation.execute
  }

};
